export var RangeEdge = {
  From: 0,
  To: 1
};